module.exports = __webpack_public_path__ + "assets/img/coupon.07e7eb2d.svg";